import { ShieldCheck, LogIn, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";

const HERO_IMAGE = "https://customer-assets-m6fa6gv7.emergentagent.net/job_hfacs-factors/artifacts/47gvhxiu_Screenshot_20260926_125649_Chrome.webp";

export default function Home() {
  const { status } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background text-foreground relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        data-testid="home-hero-background"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-transparent to-background/75" />
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/75 to-background/10" />

      <header className="relative z-10 border-b border-border/60 backdrop-blur-md bg-card/30">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-sm bg-primary/15 border border-primary/40 flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-primary" />
            </div>
            <div>
              <p className="font-heading font-black uppercase tracking-wide text-lg leading-none">HFACS</p>
              <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Analyser · Comprendre · Agir</p>
            </div>
          </div>
          <button
            onClick={() => (status === "authenticated" ? navigate("/dashboard") : handleLogin())}
            data-testid="header-login-button"
            className="font-mono text-xs uppercase tracking-wider px-4 py-2 rounded-sm border border-primary/40 bg-primary/10 hover:bg-primary/20 text-primary transition-colors flex items-center gap-2"
          >
            <LogIn className="h-3.5 w-3.5" />
            {status === "authenticated" ? "Mon tableau de bord" : "Se connecter avec Google"}
          </button>
        </div>
      </header>

      <main className="relative z-10 max-w-6xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-3xl">
          <h1 className="font-heading font-black uppercase tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mb-6">
            Plateforme d'investigation<br />
            <span className="text-primary">Facteurs Humains</span> &amp; Organisationnels
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground max-w-xl leading-relaxed mb-10">
            HFACS transforme votre méthodologie d'analyse d'incidents en un véritable poste de commandement :
            faits, investigation, Copilote IA, analyse causale, chemins critiques et plan d'actions HFIX —
            sans jamais remplacer le jugement de votre équipe.
          </p>
          <button
            onClick={() => (status === "authenticated" ? navigate("/dashboard") : handleLogin())}
            data-testid="home-cta-login-button"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground font-medium text-sm px-6 py-3 rounded-sm transition-colors"
          >
            {status === "authenticated" ? "Accéder au tableau de bord" : "Se connecter avec Google"}
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </main>

      <footer className="relative z-10 border-t border-border/60 bg-card/30 backdrop-blur-md">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between text-xs text-muted-foreground">
          <span>© 2026 Lafarge — HFACS</span>
          <Link to="/politique-confidentialite" data-testid="home-privacy-link" className="hover:text-foreground transition-colors">
            Politique de confidentialité (RGPD)
          </Link>
        </div>
      </footer>
    </div>
  );
}
